export default "__VITE_ASSET__BfjMHzP3__"